var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.56 0.63 59.89 59.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5713,
    r: 29.5,
    fill: "#F7F7F7",
    fillOpacity: 0.1,
    stroke: "#7366FF",
    strokeWidth: 0.8875
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5002,
    cy: 30.5715,
    r: 26.1604,
    fill: "#7366FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.1489 24.6341C40.1489 23.2055 38.9801 22.0366 37.5514 22.0366H33.6552V24.6341H37.5514V28.0758L33.0318 33.7253H28.4603V27.2316H23.2653C20.3951 27.2316 18.0703 29.5563 18.0703 32.4266V36.3228H20.6678C20.6678 38.4787 22.4081 40.219 24.564 40.219C26.7199 40.219 28.4603 38.4787 28.4603 36.3228H34.2786L40.1489 28.9849V24.6341ZM24.564 37.6215C23.8497 37.6215 23.2653 37.0371 23.2653 36.3228H25.8628C25.8628 37.0371 25.2783 37.6215 24.564 37.6215Z",
    fill: "#8C81FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9668 23.3354H28.4605V25.9329H21.9668V23.3354ZM40.1492 32.4266C37.9933 32.4266 36.253 34.167 36.253 36.3229C36.253 38.4788 37.9933 40.2191 40.1492 40.2191C42.3051 40.2191 44.0454 38.4788 44.0454 36.3229C44.0454 34.167 42.3051 32.4266 40.1492 32.4266ZM40.1492 37.6216C39.4349 37.6216 38.8504 37.0372 38.8504 36.3229C38.8504 35.6086 39.4349 35.0241 40.1492 35.0241C40.8635 35.0241 41.4479 35.6086 41.4479 36.3229C41.4479 37.0372 40.8635 37.6216 40.1492 37.6216Z",
    fill: "#8C81FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.14ecdc494f46d2881ad1a461eac93f41.svg";
export { ForwardRef as ReactComponent };